import e from"styled-components";const i=e.div`
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type='number'] {
		appearance: textfield;
		-moz-appearance: textfield;
	}
`,t=e.input`
	height: 40px;
	width: ${({isFullWidth:e})=>e?"100%":"40px"};
	background-color: ${({theme:e})=>e.bg.primary};
	box-sizing: border-box;
	border-radius: 8px;
	border: ${({theme:e,isFullWidth:i})=>i?"none":`1px solid ${e.border.black15}`};
	text-align: ${({isFullWidth:e})=>e?"left":"center"};

	${({isFullWidth:e})=>e&&"padding-inline: 8px;"};

	&:focus {
		outline: none;
	}
`;export{i as HideArrows,t as NumberContainer};
